import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API } from "../global/global";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

export const useGetSucursalesByPlataforma = (plataformaId?: number | null) => {
  const authContext = useContext(AuthContext);

  const { data, isLoading, refetch } = useQuery(
    ["sucursales-plataforma", plataformaId ?? "todas"], 
    async () => {
      const params: any = {};
      
      if (plataformaId) {
        params.plataforma_activa = plataformaId;
      } else {
        // Enviar 0 para indicar "todas" y evitar que el interceptor inyecte una
        params.plataforma_activa = 0;
      }

      const { data } = await axios.get(`${API}/sucursal`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + authContext.token,
        },
        params,
      });
      return data["data"];
    },
    {
      enabled: !!authContext.token,
      staleTime: 0,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
};
